import Navbar from './styles'

export default Navbar